import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false, // Overridden by user preference
    options: {
      customProperties: true, // Enable CSS variables
    },
    themes: {
      light: {
        primary: '#005D6C',
        secondary: '#007A8C',
        accent: '#003D48',
        error: '#DC2626',
        info: '#2563EB',
        success: '#16A34A',
        warning: '#D97706',
      },
      dark: {
        primary: '#005D6C',
        secondary: '#007A8C',
        accent: '#003D48',
        error: '#DC2626',
        info: '#2563EB',
        success: '#16A34A',
        warning: '#D97706',
      },
    },
  },
});
